import useAuth from "@/hooks/useAuth";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode"

interface RequiredDrawerProps {
    allowedPermissions: string[]
    
}
const RequireAuth: React.FC<RequiredDrawerProps> = ({ allowedPermissions }) => {
    const { auth } = useAuth()
    const location = useLocation()
    let roles: string[] = []
    let token: any = auth?.accessToken
    if (token !== undefined) {
        const decoded: any = jwtDecode(token);
        roles = decoded?.UserInfo.roles
    }



    return (
        roles?.find(role => allowedPermissions?.includes(role))
            ? <Outlet />
            : auth?.accessToken
                ? <Navigate to="/unauthorized" state={{ from: location }} replace />
                : <Navigate to="/" state={{ from: location }} replace />
    );
}

export default RequireAuth;